<cnet-card class="menu-mobile">
  <div class="options">
    <ng-content></ng-content>
  </div>
</cnet-card>
